import { Dispatch, SetStateAction } from 'react';
import { TFunction } from 'i18next';
import { getRequestOptionTitle } from 'pages/MyOrdersPage/InProgressOrders/FilterOptions';
import {
  FILTER_BRAND,
  FILTER_DELIVERY,
  FILTER_FEATURES,
  FILTER_FUEL_EFFICIENCY,
  FILTER_NOISE_LEVEL,
  FILTER_POSITION,
  FILTER_PRODUCT_RANGE,
  FILTER_WET_GRIP,
  FilterType,
  getDeliveryFilterData,
  getFilterBrandLabel,
  getFilterFeaturesLabel,
  getFilterFuelConsumptionLabel,
  getFilterNoiseLevelLabel,
  getFilterProductRangeLabel,
  getFilterSeasonLabel,
  getPositionLabel,
} from './Filter.types';

export interface UsePrice {
  showPriceless: boolean;
  setShowPriceless: Dispatch<SetStateAction<boolean>>;
}

const RANGE_BOUND_EPSILON = 0.000001;

const isAtBound = (value: number, bound: number) => Math.abs(value - bound) < RANGE_BOUND_EPSILON;

export const isDefaultRange = (currentMin: number, currentMax: number, min: number, max: number): boolean => {
  return isAtBound(currentMin, min) && isAtBound(currentMax, max);
};

export const getLabel = (
  t: TFunction,
  type: string,
  item: string,
  filterSectionType?: FilterType,
): string | undefined => {
  switch (type) {
    case FILTER_POSITION:
      return getPositionLabel(item, t);
    case FILTER_DELIVERY:
      return getDeliveryFilterData(item, t)?.label;
    case FILTER_FUEL_EFFICIENCY:
      return getFilterFuelConsumptionLabel(item, t);
    case FILTER_WET_GRIP:
      return getFilterFuelConsumptionLabel(item, t);
    case FILTER_FEATURES:
      return getFilterFeaturesLabel(item, t);
    case FILTER_PRODUCT_RANGE:
      return getFilterProductRangeLabel(item, t);
    case FILTER_NOISE_LEVEL:
      return getFilterNoiseLevelLabel(item, t);
    case FILTER_BRAND: {
      return getFilterBrandLabel(item, filterSectionType);
    }
    case 'VEHICLE':
      return t('order.in_progress.filter.tag.vehicle', 'Vehicle: {{vehicle}}', { vehicle: item });
    case 'REFERENCE_NUMBER':
      return t('order.in_progress.filter.tag.reference', 'Reference: {{reference}}', { reference: item });
    case 'ORDER':
      return t('order.in_progress.filter.tag.order', 'Order: {{order}}', { order: item });
    case 'ORDER_MARK':
      return t('order.in_progress.filter.tag.order_mark', 'Order mark: {{order_mark}}', { order_mark: item });
    case 'STATUS':
      return getRequestOptionTitle(t, item);
    default:
      return getFilterSeasonLabel(item, t);
  }
};
